/**
 * EasySell aux couleurs AB TOMIC.
 * EasySell écrit ses couleurs en style en ligne « !important », qu'aucune
 * feuille de style ne peut battre : on les réécrit ici, et on les réapplique
 * chaque fois qu'EasySell redessine son formulaire.
 */
(() => {
  'use strict';

  const racine = getComputedStyle(document.documentElement);
  const couleur = (nom, secours) => racine.getPropertyValue(nom).trim() || secours;
  const NOIR = couleur('--noir', '#0A0A0A');
  const NOIR_2 = couleur('--noir-2', '#1A1A1A');
  const VERT = couleur('--vert', '#B7FF00');
  const BLANC = couleur('--blanc', '#FFFFFF');
  const BORDURE = '#262626';

  /* Sélecteur → styles imposés */
  const regles = [
    ['#es-form-container', { background: NOIR_2, color: BLANC, 'border-color': BORDURE }],
    ['#es-form-container .es-form-header .mb-2', { 'font-size': '22px', color: BLANC }],
    ['#es-form-button, .es-cta-btn', { 'background-color': VERT, color: NOIR }],
    ['#es-form-button span:not(.es-loading-mask), .es-cta-btn span:not(.es-loading-mask)', { color: NOIR }],
    ['#es-form-button .es-loading-mask', { 'background-color': NOIR }],
    ['.es-popup-button', { background: VERT, color: NOIR, 'border-radius': '8px', 'border-width': '0px' }],
    ['.es-popup-button .es-button-title', { color: NOIR }],
    ['#es-sticky', { background: VERT, color: NOIR, 'border-radius': '0px', 'border-width': '0px' }],
    ['#es-sticky span:not(.es-loading-mask)', { color: NOIR }],
  ];

  const imposer = (el, styles) => {
    for (const [prop, valeur] of Object.entries(styles)) {
      if (el.style.getPropertyValue(prop) !== valeur || el.style.getPropertyPriority(prop) !== 'important') {
        el.style.setProperty(prop, valeur, 'important');
      }
    }
  };

  const appliquer = () => {
    for (const [selecteur, styles] of regles) {
      document.querySelectorAll(selecteur).forEach((el) => imposer(el, styles));
    }
  };

  /* Regroupe les changements d'un même rendu en un seul passage */
  let enAttente = false;
  const planifier = () => {
    if (enAttente) return;
    enAttente = true;
    requestAnimationFrame(() => {
      enAttente = false;
      appliquer();
    });
  };

  const demarrer = () => {
    appliquer();
    new MutationObserver(planifier).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
